import { createAction, props } from '@ngrx/store';
import { IUserRolesResponse } from '../models/user-roles.model';

export const loadAllRoles = createAction('[StaticData] Load AllRoles');

export const loadAllRolesSuccess = createAction('[StaticData] Load AllRoles Success', props<{ response: IUserRolesResponse[] }>());

export const loadAllRolesFailure = createAction('[StaticData] Load AllRoles Failure', props<{ error: any }>());
